import $ from "jquery";
import AjaxBlocking from "./AjaxBlocking";

export default class GetProductsByAttr {
    constructor() {
        this.filter_el = Array.from(
            document.getElementsByClassName(".js-attr-filter")
        );
        this.filter_el = document.getElementsByClassName("js-attr-filter");
        this.deleteElementsBtn =
            document.getElementsByClassName("jsDeleteFilter");
        this.attrList = new Map();
        this.activeFilters = [];
        this.selectedSort = "date_desc";
        this.sidebar = document.getElementById("jsSidebar");
        this.sortBySelect = document.querySelector(".jsSortBySelect");
        this.containerOfProds = document.getElementById("jsProdContainer");
        this.paginationLinks = document.querySelector(".js-change-page");
        this.paginationNextPrev = document.querySelector(
            ".js-change-prevnext-page"
        );
        this.pageNumber = 1;
        this.categoryTitle = document.querySelector(".archive-products__title");
        this.activesFiltersBox = document.getElementById("actives-filters");
        this.urlString = new URL(window.location.href);
        this.attributes = document.querySelector(".product-sidebar__wrap");
    }

    init() {
        this.events();
    }

    events() {
        window.addEventListener("DOMContentLoaded", () => {
            this.initializeSelectField();
        });

        $("body").on("click", ".js-attr-filter", (event) => {
            event.preventDefault();
            const attrName = event.target.dataset.info;
            const attrKey = event.target.dataset.key;

            event.target.classList.remove("js-attr-filter");

            event.target.classList.add(
                "product-sidebar__list-item--active",
                "jsDeleteFilter"
            );

            if (!this.attrList.get(attrKey)) {
                this.attrList.set(attrKey, [attrName]);
            } else {
                if (!this.attrList.get(attrKey).includes(attrName)) {
                    this.attrList.get(attrKey).push(attrName);
                }
            }

            if (!this.activeFilters.includes(attrName)) {
                this.activeFilters.push(attrName);
            }

            this.pageNumber = 1;

            this.get_posts_by_attr(Array.from(this.attrList));
        });

        $("body").on("click", ".jsDeleteFilter", (event) => {
            const deleteFilter = event.target.dataset.delete;
            const deleteKey = this.getKey(deleteFilter);
            const deleteElIndex = this.attrList
                .get(deleteKey)
                .indexOf(deleteFilter);
            const getActiveIndex = this.activeFilters.indexOf(deleteFilter);
            if (this.attrList.get(deleteKey).length > 1) {
                this.attrList.get(deleteKey).splice(deleteElIndex, 1);
            } else {
                this.attrList.delete(deleteKey);
            }
            this.activeFilters.splice(getActiveIndex, 1);

            event.target.classList.add("js-attr-filter");

            event.target.classList.remove(
                "product-sidebar__list-item--active",
                "jsDeleteFilter"
            );

            this.pageNumber = 1;

            this.get_posts_by_attr(Array.from(this.attrList));
        });

        $("body").on("click", ".js-change-page", (event) => {
            event.preventDefault();
            this.pageNumber = event.target.dataset.pagenum;
            this.get_posts_by_attr(Array.from(this.attrList));
        });

        $("body").on("click", ".js-change-prevnext-page", (event) => {
            event.preventDefault();
            if (event.target.dataset.pagenum === "prev") {
                this.pageNumber--;
            } else if (event.target.dataset.pagenum === "next") {
                this.pageNumber++;
            }
            this.get_posts_by_attr(Array.from(this.attrList));
        });
    }

    checkParamUrl() {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const page = urlParams.get("page");

        if (page > 1) {
            this.pageNumber = page;
            this.get_posts_by_attr(Array.from(this.attrList));
        }
    }

    initializeSelectField() {
        const select = this.sortBySelect;

        if (!select) return;

        $(select).select2({
            minimumResultsForSearch: -1,
            dropdownCssClass: "dropdown-simple",
        });

        $(select).on("select2:select", (e) => {
            this.sortProductsTrigger(e);
        });
    }

    sortProductsTrigger(event) {
        if ($(event.target).hasClass("search-form__input")) {
            this.urlString.searchParams.set("s", event.target.value);
            const newUrl = this.urlString;
            document.location.href = newUrl;
            return;
        }

        this.selectedSort = event.params.data.id;
        this.get_posts_by_attr(Array.from(this.attrList));
    }

    getKey(value) {
        return [...this.attrList].find(([key, val]) => val.includes(value))[0];
    }

    // eslint-disable-next-line camelcase
    get_posts_by_attr(attrList) {
        const data = {
            action: "get_products_by_attr",
            attr: attrList,
            active: Array.from(this.activeFilters),
            sortBy: this.selectedSort,
            page: this.pageNumber,
            category: this.categoryTitle.dataset.catId,
            s: this.urlString.searchParams.get("s")
                ? this.urlString.searchParams.get("s")
                : "",
        };

        $.ajax({
            // eslint-disable-next-line no-undef
            url: ajax.ajaxurl,
            type: "POST",
            data: data,
            beforeSend: () => {
                this.blockForAjax();
            },
            success: (response) => {
                if (response) {
                    this.containerOfProds.innerHTML = response.data.products;

                    const widthWindow =
                        window.innerWidth ||
                        document.documentElement.clientWidth ||
                        document.body.clientWidth;

                    if (widthWindow < 1200) {
                        this.attributes.classList.remove("open");
                    }

                    const params = new URLSearchParams(window.location.search);

                    const loc = new URL(window.location.href);

                    let pathName = loc.pathname;

                    const posPath = pathName.indexOf("page/");

                    if (posPath > 0) {
                        pathName = pathName.slice(0, posPath);
                    }

                    let newUrl =
                        loc.origin + pathName + "page/" + this.pageNumber + "/";

                    if (params.toString().length > 0) {
                        newUrl += "?" + params.toString();
                    }

                    window.history.pushState("", "", newUrl);

                    this.unblockForAjax();
                    window.setTimeout(() => {
                        window.scrollTo({
                            top: 0,
                            behavior: "smooth",
                        });
                    }, 500);
                }
            },
            error: function (request) {
                console.log(request.responseText);
                this.unblockForAjax();
            },
        });
    }

    blockForAjax() {
        if (!this.containerOfProds) return;

        const myBlock = new AjaxBlocking();
        myBlock.blockOnAjax(this.containerOfProds);
    }

    unblockForAjax() {
        if (!this.containerOfProds) return;

        const myBlock = new AjaxBlocking();
        myBlock.unblockOnAjax(this.containerOfProds);
    }
}
